import { type FC } from "react";
import { useSelector } from "react-redux";

import ExperienceSettingsFormLayer from "@/VisualBuilder/components/ExperienceSettingsDialog/ExperienceSettingsFormLayer";
import { REQUEST_STATUSES, ROLES, SORT_FIELD, SORT_ORIENTATION } from "@/constants";
import { useMembersData, useUrlParams } from "@/hooks";
import { useOrganizationUsersData } from "@/hooks/useOrganizationUsersData";
import { currentExperienceSelector } from "@/store/v2/currentExperience/selectors";

export interface ExperienceSettingsFormValues {
  title: string;
  locked: boolean;
  dbcEnabled: boolean;
  dbcUserId: number;
  userCollectionSync: boolean;
  propertyInfoCardEnabled: boolean;
}

interface ExperienceSettingsModalProps {
  readonly open: boolean;
  readonly onCloseDialog: () => void;
}

const ExperienceSettingsModal: FC<ExperienceSettingsModalProps> = ({ open, onCloseDialog }) => {
  const params = useUrlParams();

  const { propertyId, userId, organizationId } = params;
  const { experience, status } = useSelector(currentExperienceSelector);

  useMembersData({
    propertyId,
    sortField: SORT_FIELD.MEMBER_NAME,
    sortOrientation: SORT_ORIENTATION.ASC,
    roles: [ROLES.PROPERTY_ADMIN, ROLES.SALESPERSON],
  });

  useOrganizationUsersData({
    organizationId: Number(organizationId),
    hookEnabled: !!organizationId,
  });

  return (
    status === REQUEST_STATUSES.SUCCEEDED && (
      <ExperienceSettingsFormLayer
        experience={experience}
        open={open}
        onCloseDialog={onCloseDialog}
        propertyId={`${propertyId}`}
        userId={`${userId}`}
      />
    )
  );
};

export default ExperienceSettingsModal;
